export default "__VITE_ASSET__DgRsyR9z__"